import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Row, Col, Label, Button,Table } from "reactstrap";
import {inject, observer} from "mobx-react";
import CardBookingContainers from './CardBookingContainers';
import CardBookingStore from '../stores/CardBookingStore';
import FormSelect from '../../../../comum/components/FormSelect';
import FormInput from '../../../../comum/components/FormInput';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import { IconeDelete, IconeEditar, IconeBuscar, IconeSetaSubir, IconeSetaDescer, IconeGenerico } from '../../../../comum/components/Icones';
import ModalAviso from "../../../../comum/components/ModalAviso";
import moment from 'moment';
import hrefDestinosZip from "../../../../../assets/downloads/Tecon_Rio_Grande_Lista_Destino_Final.xlsx"
import { terminal } from '../../../../../config/Constantes';

@inject("store")
@observer
export default class CardBooking extends React.Component {
    constructor(props) {
        super(props);
        
        this.appStore = this.props.store.appStore;
        this.parametrosStore = this.props.store.parametrosStore;

        this.controller = new CardBookingStore(this.props.tipoAgenda);
        this.codigoBooking = this.props.codigoBooking;
        this.containerExcluido =  null;
        this.state = {
            refreshBooking : false,
            refreshContainer : false
        }
        
        this.handleOnChange = this.handleOnChange.bind(this);
        this.handleOnChangeContainer = this.handleOnChangeContainer.bind(this);
        this.handleOnBlur = this.handleOnBlur.bind(this);
        this.handleOnBlurContainer = this.handleOnBlurContainer.bind(this);
        this.expandido = this.props.booking.collapsed;
    };

    componentDidMount() {
        if(this.props.booking.NumBooking){
            this.controller.carregarLista(this.props.booking.NumBooking);
        }
        this.controller.carregarDestinos();

        //Fainas Entrada de cntr cheio, Entrada de cntr cheio mapa e Entrada de cntr vazio, não carrega categoria sem definir um destino final.
        if(!["ECC","ECCM", "ECV", "23ECV"].includes(this.props.tipoAgenda.codIdentificador))
            this.controller.carregarCategorias(null);

        this.controller.carregarLacres();

        this.controller.carregarPortos(_.get(this.props.booking, 'ArmId'), _.get(this.props.booking, 'VesselvisitId'));
        this.controller.carregarArmadores(_.get(this.props.booking, 'VesselvisitId'));
        
        if (this.props.isEditar) {
            this.checarBooking();
            this.controller.editandoBooking = false;
        }        
    };

    checarBooking = () => {
        if(this.props.booking.NumBooking && !["ECVB","ECV", "23ECV"].includes(this.props.tipoAgenda.codIdentificador)) {
            this.controller.service.buscarDadosPorBooking(this.props.booking.NumBooking).then(response => {
                if (response && response.data) {
                    this.props.booking.bookingExistente = true;
                }                 
                else {
                    this.props.booking.bookingExistente = false;
                }
            }).catch(error => {
                this.props.booking.bookingExistente = false;
                console.log(error);
            });
        }
    }

    handleExpandir = () => {
        this.controller.clickExpandir(this.props.booking);
        this.props.collapseBookings(false, this.props.index);
    };
    
    handleRetrair = () => {
        this.props.collapseBookings(true, this.props.index);
    };

    handleRemover = () => this.props.remover(this.props.index);

    handleRemoverContainer = (index, posContainer) => {
        
        if (this.props.booking.containerAtivo === posContainer) 
            this.props.setDadosAgendamentoSemPensar(`${this.props.dado}.containerAtivo`, -1);        
        
        this.containerExcluido =  posContainer; 
        
        this.props.removerContainer(index, posContainer);      
        setTimeout(function() {
            this.setState({refreshContainer: true});
        }.bind(this), 1);        
    };

    handleDuplicad = () => this.props.duplicar(this.props.index);

    onChangeOper = (campo, event) => {
        if (event!=null) {
            this.controller.carregarPortos(_.get(this.props.booking, 'ArmId'), event.value);
            this.controller.carregarArmadores(event.value);
        }
        this.props.setDado(campo, event);
    };

    onChangeArmador = (campo, event) => {
        if (event!=null) {
            this.controller.service.armadorPermiteCriacaoBooking(event.value).then(response => {
                if(response.data){
                    if(response.data.Permitido | ["ECVB","ECV", "23ECV"].includes(this.props.tipoAgenda.codIdentificador)){
                        this.controller.carregarPortos(event.value, _.get(this.props.booking, 'VesselvisitId'));
                        this.props.setDado(campo, event);
                    } else {
                        this.controller.listaMensagens = [response.data.Mensagem];
                        this.props.setDado(campo, null);
                    }
                }
            }).catch( erro => {
                console.log(erro)
            });     
        }        
    };

    handleChangeTipoCntr = (campo, event) => {
        if (event!=null)
            this.controller.carregarISOs(event.value, this.props.booking.NumBooking);
        this.props.setDado(campo, event);
    };

    handleContainersVazio = () => { };

    handleSelecionaContainer = (posContainer, CdTipoCntr) => {
        
        if (this.containerExcluido != null)
        {
           posContainer = (this.containerExcluido===0) ? 0 : this.containerExcluido;
           this.containerExcluido = null;
           this.parametrosStore.isAgendamentoVisible("ListaContainerContainer"); 
        }     

        //Validar container do booking com o da nota
        this.props.agendamentoController.validarContainerBookingNotas();

        //Verificando o Resp. Ovação (Bloqueia/desbloqueia item)
        if (this.props.isEditar)
        {
            const cnpj = this.props.booking.containers[posContainer].CnpjRespOva;
            const container = `${this.props.dado}.containers[${posContainer}]`;            
            this.controller.carregarRespOva(cnpj, container, this.props.setDadosAgendamentoSemPensar, process.env.rig, posContainer);
        }
        
        if (posContainer < this.props.booking.containers.length )
        {   
            this.props.setDadosAgendamentoSemPensar(`${this.props.dado}.containerAtivo`, posContainer)
            if(!process.env.rig) {
                this.controller.carregarTiposDeContainer(this.props.booking.NumBooking);
                this.controller.carregarISOs(CdTipoCntr, this.props.booking.NumBooking);
            }
            this.controller.validarISOCarregarMercadorias(_.get(this.props.booking.containers, `[${posContainer}].CdIso`), this.props.dado, this.props.setDadosAgendamentoSemPensar);
    
            const tipo = _.get(this.props.booking.containers, `[${posContainer}].CdTipoMerc`);
            const cntr = `${this.props.dado}.containers[${posContainer}]`;
            
            this.controller.changeTiposMercadoria(
                cntr,
                tipo,
                this.props.setDadosAgendamentoSemPensar);   
            
            const cntrNome = _.get(this.props.booking.containers, `[${posContainer}].CodCntr`);
    
            if (this.controller.atualizandoContainer) {
                this.controller.setContainerAtualizado(cntrNome)
            }             
        
        }
        else 
            this.props.setDadosAgendamentoSemPensar(`${this.props.dado}.containerAtivo`, -1);
        
    };

    alertaInfoContainer = () => {
        return this.props.agendamentoController.exibeAlertaBookingNotas != null &&
            this.props.agendamentoController.exibeAlertaBookingNotas &&
            <div className="card-atencao narrow float ">
                <div className="d-flex w-100 justify-content-between align-items-center">
                    <div className="card-atencao--title">
                        Atenção!
                    </div>
                </div>
                <div className={this.classLabel}>
                    <p className="mb-0">
                        <label>
                            {this.props.agendamentoController.alertaBookingNotas != null 
                            && this.props.agendamentoController.alertaBookingNotas.length > 0 
                            && this.props.agendamentoController.alertaBookingNotas.map(alerta =>
                                <div>{alerta}</div>
                            )}
                        </label>
                    </p>
                </div>
            </div>
    }
    alertaSSA3 = () => {
        let alerta = (<div/>)
        if (process.env.ssa)
        {
        alerta = (                
            <div class="alert alert-primary" role="alert">
                        <div className="card-atencao--title"> 
                        Atenção:                        
                        </div>
                        Caso a unidade seja depositada com navio divergente, incidirá custo de transferência de lote.
                </div>    
        )
        }
        return alerta;
    }
    listaContainers() {
        return <div>
                {this.alertaInfoContainer()}
                
                <Row>
                    <Col>
                        <h2>Containers</h2>
                    </Col>
                </Row>

                <Row className="sub-detalhes">
                    <Col md={3}>
                        {
                            this.props.booking.containers &&
                                this.props.booking.containers.map((container, posContainer) => (
                                    <div key={posContainer} className={`card-branco clicavel ${this.props.booking.containerAtivo === posContainer && "card-selecionado"}`} 
                                                         onClick={() => this.handleSelecionaContainer(posContainer, container.CdTipoCntr)} >
                                        <Row>
                                            <Col xs={6} sm={6} md={8}>
                                               {
                                                <FormInput
                                                    classNames = {'input-titulo'}
                                                    objeto={this.props.booking.containers[posContainer]}
                                                    dado={ `CodCntr` }
                                                    limiteMaximo={11}
                                                    onChange={(event) => this.handleOnChangeContainer(event, this.props.index, posContainer)}
                                                    onBlur={ ()=> {!this.props.isEditar ? this.handleOnBlurContainer(this.props.index, posContainer, _.get(container, "CodCntrTemp")): null}}
                                                    placeholder="Nº Container" 
                                                    bloqueado = { this.props.isEditar}
                                                />
                                                }
                                            </Col>
                                            <Col xs={6} sm={6} md={4}>
                                                <div className="float-right">
                                                {!this.props.isEditar ? <IconeDelete tamanho="lg" onClick={ () => this.handleRemoverContainer(this.props.index, posContainer)} /> :""}
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row>
                                            { container.padraoContainer
                                                &&  <Col  className=" ml-4 col-label label-obrigatorio px-0">
                                                        <Label>Padrão inválido</Label>
                                                    </Col>
                                            }
                                        </Row>
                                    </div>
                            ))
                        }
                        {!this.props.isEditar ? <div className="card-inserir-novo clicavel" onClick={ () => this.props.adicionarNovoContainer(this.props.index) } >
                            <Row>
                                <Col>
                                    <Label className="clicavel">Novo Container</Label>
                                </Col>
                            </Row>
                        </div>: ""}
                    </Col>
                    { //(!this.props.isEditar || this.controller.ISOs) &&
                        this.props.booking.containers &&
                            this.props.booking.containers.map((container, posContainer) => (
                                <CardBookingContainers 
                                    index={posContainer} key={posContainer}
                                    booking={this.props.booking}
                                    tipoAgenda={this.props.tipoAgenda}
                                    tiposContainer={this.props.tiposContainer}
                                    terminal={this.props.terminal}
                                    isEditar={ this.props.isEditar }
                                    hide={ !(this.props.booking.containers && this.props.booking.containerAtivo === posContainer) }
                                    controller={ this.controller }
                                    agendamentoController = {this.props.agendamentoController}
                                    tiposMercadoria={ this.props.tiposMercadoria }
                                    dado={ `${this.props.dado}.containers[${posContainer}]` }
                                    container={ container }
                                    adicionarLacre={ () => this.props.adicionarLacre(this.props.index, posContainer) }
                                    removerLacre={ (posLacre) => this.props.removerLacre(this.props.index, posContainer, posLacre) }
                                    atualizaLacres={ this.props.atualizaLacres }
                                    salvo={ this.props.salvo }
                                    ncmAtivo={ this.props.ncmAtivo }
                                    setDado={ this.props.setDado }
                                    setDadosLacre={ this.props.setDadosLacre }
                                    validacaoCampos={this.props.validacaoCampos}
                                    setDadosAgendamentoSemPensar={ this.props.setDadosAgendamentoSemPensar}
                                    dadosMercadoria = {this.props.dadosMercadoria}
                                    setStatusSalvo = {this.props.setStatusSalvo} 
                                />
                        ))
                    }
                </Row>
            </div>
    };

    listaDadosBooking() {
        return <div>
                    <Row className="area-form">
                        { this.parametrosStore.isAgendamentoVisible("ListaContainerOperacao") 
                            && (this.isCodigoNovo() ? 
                                <FormInput xs={12} sm={12} md={3} titulo="Operação"
                                    bloqueado={ true }
                                    objeto={ this.props.booking }
                                    dado={ "VesselvisitId" }
                                    value={_.get(this.props.booking, `IdViagemDtPrev`)}
                                    bloqueado={ !this.props.operacoes || !this.parametrosStore.isAgendamentoEnabled("ListaContainerOperacao") || this.isCodigoNovo() }
                                    onChange={ (event) => this.onChangeOper(`${this.props.dado}.VesselvisitId`, event) }                                                  
                                /> 
                                : 
                                <FormSelect xs={12} sm={12} md={3} titulo="Operação"
                                    bloqueado={ !this.props.operacoes || !this.parametrosStore.isAgendamentoEnabled("ListaContainerOperacao") || this.isCodigoNovo() }
                                    objeto={ this.props.booking }
                                    dado={ "VesselvisitId" }
                                    itens={ this.props.operacoes }
                                    itensValor="Viagem" itensLabel="IdViagemDtPrev"
                                    onChange={ (event) => this.onChangeOper(`${this.props.dado}.VesselvisitId`, event) } 
                            />)
                         }
                        { this.parametrosStore.isAgendamentoVisible("ListaContainerArmador")
                            && (this.isCodigoNovo() ? 
                                <FormInput xs={12} sm={12} md={3} titulo="Armador"
                                    objeto={ this.props.booking }
                                    dado={ "ArmId" }
                                    value={_.get(this.props.booking, `ApelidoArmador`)}
                                    bloqueado={ true }
                                    //alerta={ (this.props.salvo && !_.has(this.props.booking, "ArmId")) ? "Campo obrigatório" : "" }
                                    onChange={ (event) => this.onChangeArmador(`${this.props.dado}.ArmId`, event) }                                                 
                                /> 
                                : 
                                <FormSelect xs={12} sm={12} md={3} titulo="Armador"
                                    itens={ this.controller.armadores }
                                    objeto={ this.props.booking }
                                    dado={ "ArmId" }
                                    itensValor="ArmArmIdSai" itensLabel="ApelidoArmador"
                                    bloqueado={ !this.parametrosStore.isAgendamentoEnabled("ListaContainerArmador") || this.isCodigoNovo() }
                                    //alerta={ (this.props.salvo && !_.has(this.props.booking, "ArmId")) ? "Campo obrigatório" : "" }
                                    onChange={ (event) => this.onChangeArmador(`${this.props.dado}.ArmId`, event) } 
                            />
                            )
                         }
                        { this.parametrosStore.isAgendamentoVisible("ListaContainerPorto")
                            && (this.isCodigoNovo() ? 
                                <FormInput xs={12} sm={12} md={3} titulo="Porto"
                                    objeto={ this.props.booking }
                                    dado={ "CdPorto" }
                                    value={_.get(this.props.booking, `NomePorto`)}
                                    bloqueado={ true }
                                    onChange={ (event) => this.props.setDado(`${this.props.dado}.CdPorto`, event) }                                                 
                                /> 
                                : 
                                <FormSelect xs={12} sm={12} md={3} titulo="Porto"
                                    itens={ this.controller.portos }
                                    objeto={ this.props.booking }
                                    dado={ "CdPorto" }
                                    itensValor="CdPorto" itensLabel="DscPorto"
                                    bloqueado={ !this.parametrosStore.isAgendamentoEnabled("ListaContainerPorto") || this.controller.portosBloqueado || this.isCodigoNovo() }
                                    onChange={ (event) => this.props.setDado(`${this.props.dado}.CdPorto`, event) } 
                            />
                            )
                         }
                        { this.parametrosStore.isAgendamentoVisible("ListaContainerDestino")
                            &&  <Col className="d-flex justify-content-between align-content-between"> 
                                    <form className="d-flex justify-content-between align-content-between">
                                        <div className="form-row">
                                            <div className="form-group col-6">
                                                <FormInput titulo="Destino"  
                                                        limiteMaximo={5}
                                                        objeto={ this.props.booking }
                                                        dado={ "LcCdLoc" }
                                                        bloqueado={ !this.parametrosStore.isAgendamentoEnabled("ListaContainerDestino") || this.isCodigoNovo()}
                                                        onChange={ (event) => this.validarDestino(event) }                                                 
                                                /> 
                                            </div>
                                            <div style={{
                                                    position: 'absolute', left: '30%', top: '50%',
                                                    transform: 'translate(-30%, -50%)'
                                                }} >
                                                <Col>
                                                    <h4><a href={hrefDestinosZip} download="Tecon_Rio_Grande_Lista_Destino_Final.xlsx">[<IconeGenerico icone="question" tamanho="xs"> </IconeGenerico>]</a></h4>
                                                </Col>
                                            </div>
                                        </div>
                                    </form>
                                </Col>
                        }
                    </Row>
                </div>
    }

    excluiDadosContainers = () => {
        setTimeout(() => {
            this.setState({refreshBooking: false, refreshContainer : false });
        }, 1000);
        return <div></div>
    };
    
    excluiDadosBooking = () => {
        setTimeout(() => {
            this.setState({refreshBooking: false, refreshContainer : true }); 
        }, 1000);
        return <div></div>
    };

    listaDeCodCntr = () => {
        let lista = "";
        if (this.props.booking.containers)
            this.props.booking.containers.forEach((cntr, x) => {
                if (x > 0) {
                    lista = lista + "  /  "
                }
                lista = lista + cntr.CodCntr;
            });
        return lista;
    };

    modalErro() {
        if(this.controller.listaMensagens) {
            return <ModalAviso onClickFechar={()=>this.controller.fecharModais()}>
                {
                    this.controller.listaMensagens &&
                    this.controller.listaMensagens.map((msg, x) =>
                        <h2 key={x}>{ msg }</h2>
                    )
                }
            </ModalAviso>
        }
    }

    isCodigoNovo () {
       return this.props.booking.bookingExistente;
    }

    habilitarEdicaoBooking = () => {
        _.set(this.props.booking,'NumBookingTemp', _.get(this.props.booking, `NumBooking`));
        this.controller.editandoBooking = true;
    }

    validarDestino = (event) => {
        this.props.setDado(`${this.props.dado}.LcCdLoc`, event);
        
        if(["ECC","ECCM","ECV", "23ECV"].includes(this.props.tipoAgenda.codIdentificador))
            this.controller.carregarCategorias(_.get(this.props.booking, `LcCdLoc`));
    } 

    handleOnBlur = () => {
        this.controller.carregarLista(this.props.booking, `NumBookingTemp`);
        //Verificar se o booking é diferente do já cadastrado
        if(_.get(this.props.booking, `NumBooking`) !== _.get(this.props.booking, `NumBookingTemp`)){
            //Pegar o booking temporário e definir como principal
            _.set(this.props.booking,'NumBooking', _.get(this.props.booking, `NumBookingTemp`));
            this.props.setDado(`${this.props.dado}.NumBookingTemp`, null);
            
            
            if(this.props.booking.containers) {
                this.props.booking.containers.map((container, posContainer) => {
                    _.set(this.props.booking.containers[posContainer],'CdTipoMerc', null);
                    if (process.env.rig)
                    {
                        _.set(this.props.booking.containers[posContainer],'ValUmid', null);
                        _.set(this.props.booking.containers[posContainer],'ValVent', null);
                        _.set(this.props.booking.containers[posContainer],'ValTmpIdea', null);
                        _.set(this.props.booking.containers[posContainer],'IdUn', null);
                    }                    
                });
            }

            this.codigoBooking = _.get(this.props.booking, `NumBooking`);
            this.props.onBlurEvent(this.codigoBooking, this.props.index);    
            this.setState({refreshBooking: true, refreshContainer : false });  
        }
        this.controller.editandoBooking = false;
    }
    
    handleOnBlurContainer = (posBooking, posContainer, container ) => {
        container = container ? container.toUpperCase() : "";
        if(_.get(this.props.booking.containers[posContainer],'CodCntr') != container){
            _.set(this.props.booking.containers[posContainer],'CodCntrTemp', null);
            //RIG só carrega dados do cntr a primeira vez. SSA carrega toda troca de código de cntr.
            if(process.env.rig){
                if (_.get(this.props.booking.containers[posContainer],'CodCntr'))  {
                    _.set(this.props.booking.containers[posContainer],'CodCntr', container);
                    _.set(this.props.booking.containers[posContainer],'CdIso', null);
                    this.controller.ISOsBloqueado = false;
                    setTimeout(() => {
                        this.controller.ISOsBloqueado = true;
                    }, 1);
                } else {
                    this.props.onBlurEventContainer(posBooking, posContainer, container);
                    this.setState({refreshBooking: false, refreshContainer : true });  
                    setTimeout(() => {
                        this.props.atualizarMensagemContainerNotas();
                    }, 1000);
                }
            } else {
                if (_.get(this.props.booking.containers[posContainer],'CodCntr'))  {
                    _.set(this.props.booking.containers[posContainer],'CodCntr', null);
                }
                this.props.onBlurEventContainer(posBooking, posContainer, container);
                setTimeout(() => {
                    this.setState({refreshBooking: false, refreshContainer : true });
                    this.props.atualizarMensagemContainerNotas();
                }, 2000);
            }
        }
    }

    handleOnChange = (event) => {
        this.props.setDado(`${this.props.dado}.NumBookingTemp`, event);  
    }
    
    handleOnChangeContainer = (event, posBooking, posContainer,) => {
        this.props.setDado(`${this.props.dado}.containers[${posContainer}].CodCntrTemp`, event);
    }
    navioDataPopOverCadastrar = (cell, row ) => {
        if (row.Navio){
           return (
               <div id={`navio_${row.Navio ? row.Navio.NavioId : ""}`}>
                   <div className={row.Navio.ServicoNome ? "popover__wrapperCadastrar" : ""}>
                       <a href="#">
                       <span>{row.Navio.Viagem ? row.Navio.NavioNome : "---"}</span>
                           <FontAwesomeIcon
                               icon="external-link-square-alt"
                               className="ml-1 mb-1 card-detalhe--pop-color card-detalhe--clickable"
                           />
                          
                       </a>
                       <div className="popover__content_rightCadastrar">
                           <Table className="mx-0 px-0" responsive hover striped borderless>
                               <thead className="linhaDetalhesDaOperacao">
                                   <tr>
                                       <th className="small-title" colSpan="2" width="100%"><b>Detalhes da Operação</b></th>
                                   </tr>
                               </thead>
                               <tbody className = "TabelaCadastrar">
                                   <tr>
                                       <td className="small-titleCadastrar" colSpan="2" align="center"><b>Dados Gerais</b></td>
                                   </tr>
                                   <tr>
                                       <td className="small-colCadastrarCinza" width="50%"><strong>Serviço</strong></td>
                                       <td className="small-colCadastrarCinza" width="50%">{row.Navio.ServicoNome}</td>
                                   </tr>
                                   <tr>
                                       <td className="small-colCadastrarPreto" width="50%">Previsão de Início</td>
                                       <td className="small-colCadastrarPreto" width="50%">{row.Navio.EtaFormat}</td>
                                   </tr>
                                   <tr>
                                       <td className="small-colCadastrarCinza" width="50%">Previsão de Final</td>
                                       <td className="small-colCadastrarCinza" width="50%">{row.Navio.EtdFormat}</td>
                                   </tr>
                                   <tr>
                                       <td className="small-colCadastrarPreto" width="50%">Atracação Real</td>
                                       <td className="small-colCadastrarPreto" width="50%">{row.Navio.ChegadaRealFormat}</td>
                                   </tr>
                                   <tr>
                                       <td className="small-colCadastrarCinza" width="50%">Início Real</td>
                                       <td className="small-colCadastrarCinza" width="50%">{row.Navio.InicioRealFormat}</td>
                                   </tr>
                                   <tr>
                                       <td className="small-colCadastrarPreto" width="50%">Fim Real</td>
                                       <td className="small-colCadastrarPreto" width="50%">{row.Navio.FimRealFormat}</td>
                                   </tr>
                                   <tr>
                                       <td className="small-colCadastrarCinza" width="50%">Desatracação</td>
                                       <td className="small-colCadastrarCinza" width="50%">{row.Navio.PartidaRealFormat}</td>
                                   </tr>
                                   <tr>
                                       <td className="small-titleCadastrar" colSpan="2" align="center"><b>Recebimento da Carga e Container</b></td>
                                   </tr>
                                   <tr>
                                       <td className="small-colCadastrarCinza" width="50%">Início</td>
                                       <td className="small-colCadastrarCinza" width="50%">{row.Navio.InicioRecebCheioFormat}</td>
                                   </tr>
                                   <tr>
                                       <td className="small-colCadastrarPreto" width="50%">Deadline</td>
                                       <td className="small-colCadastrarPreto" width="50%">{row.Navio.DeadlineDryFormat}</td>
                                   </tr>
                               </tbody>
                           </Table>
                       </div>
                   </div>
               </div>
           )
       }
   }
    render() {
        let lista =  this.controller.bookingLista && this.controller.bookingLista.length > 0 ?  this.controller.bookingLista : [];
        
        let loading = this.controller.loading;
    	return (
            <div className="card-expansivel">
                { this.modalErro() }
                <div className={ this.props.booking.collapsed ? "card-branco" : "card-branco escondido" } >
                    <Row className="titulo-booking">
                        <Col>
                            <h2>{ _.get(this.props.booking, `NumBooking`) ? _.get(this.props.booking, `NumBooking`).toUpperCase() : "" }
                                { _.has(this.props.booking, `IndStatus`) &&
                                    <Label className="situacao-btn em-espera">{ _.get(this.props.booking, `IndStatus`) }</Label>
                                }
                            </h2>
                            <Label className="subtitulo label-disabled">{ this.listaDeCodCntr() }</Label>
                        </Col>
                        <Col>
                            <div className="float-right">
                                { this.parametrosStore.isAgendamentoVisible("ListaContainerBooking") && !this.props.isEditar &&
                                <IconeDelete className="icone-delete-toolbox" tamanho="2x" onClick={ this.handleRemover } />}
                                <Button onClick={this.handleExpandir} outline className="collapseItem" active={ false }>
                                        { this.props.booking.collapsed ? <IconeSetaDescer tamanho="lg" /> :  <IconeSetaSubir tamanho="lg" /> }
                                </Button>
                            </div>
                        </Col>
                    </Row>
                </div>
                <div className={ this.props.booking.collapsed ? "detalhes-ativo escondido" : "detalhes-ativo"}>
                    <div className="card-branco titulo">
                        <Row className="titulo-booking align-items-center">
                            <Col>
                            
                                <div>
                                { this.parametrosStore.isAgendamentoVisible("ListaContainerBooking") 
                                 && 
                                 
                                    <FormInput 
                                        classNames = {'input-titulo input-com-botao'}
                                        titulo="&nbsp;" xs={10} sm={11} md={7}
                                        objeto={this.props.booking}
                                        dado={ `NumBooking` }
                                        limiteMaximo={20}
                                        onChange={(event) => this.handleOnChange(event)}
                                        onBlur={this.handleOnBlur} 
                                        bloqueado={!this.controller.editandoBooking && (this.props.booking.NumBooking!==undefined && this.props.booking.NumBooking!=="" && this.props.booking.NumBooking!==null)}
                                        placeholder={ process.env.rig && ["ECV", "23ECV"].includes(this.props.tipoAgenda.codIdentificador) ? "Nº Booking (opcional)" : "Nº Booking" } 
                                    />
                                }
                                { this.parametrosStore.isAgendamentoVisible("ListaContainerBooking")  &&
                                    (!this.props.isEditar && !this.controller.editandoBooking && (this.props.booking.NumBooking!==undefined && this.props.booking.NumBooking!=="" && this.props.booking.NumBooking!==null)) && 
                                    <IconeEditar className="botao-input" tamanho="lg" onClick={ this.habilitarEdicaoBooking } /> }
                                { this.parametrosStore.isAgendamentoVisible("ListaContainerBooking")  &&
                                    (this.controller.editandoBooking || this.props.booking.NumBooking===undefined || this.props.booking.NumBooking==="" || this.props.booking.NumBooking===null) && 
                                    <IconeBuscar className="botao-input" tamanho="lg" onClick={ this.handleOnBlur } /> }
                                </div>
                                
                            </Col>
                            <Col>
                                <div className="float-right">
                                    { this.parametrosStore.isAgendamentoVisible("ListaContainerBooking")  && !this.props.isEditar && 
                                    <IconeDelete className="icone-delete-toolbox" tamanho="2x" onClick={ this.handleRemover } /> }
                                    <Button onClick={this.handleRetrair} outline className="collapseItem" active={ true }>
                                        { this.props.booking.collapsed ? <IconeSetaDescer tamanho="lg" /> :  <IconeSetaSubir tamanho="lg" /> }
                                    </Button>
                                </div>
                            </Col>
                        </Row>
                        <br/><br/><br/>
                        <Row >                            
                            <Col className="detalhes-do-booking-linha">Booking</Col>
                            <Col className="detalhes-do-booking-linha">Navio / Viagem</Col>
                            <Col className="detalhes-do-booking-linha">Porto Desc</Col>
                            <Col className="detalhes-do-booking-linha">Destino</Col>
                            <Col className="detalhes-do-booking-linha">Tam/Tipo</Col>
                            <Col className="detalhes-do-booking-linha">QTD Agendados</Col>
                                                       
                            
                        </Row>
                        <hr className="linha-detalhe-do-booking"></hr>
                        
                            { lista && lista.length == 0 ? <div></div> : 
                                lista.map((c)=>
                                <Row>
                                <Col className="detalhes-do-booking-linha2">{c.booking.Nbr}</Col>
                                <Col className="detalhes-do-booking-linha2">{this.navioDataPopOverCadastrar(null,c)}<br/>{c.Navio != null && c.Navio.Viagem != null ? (c.Navio.Viagem):('')}</Col>
                                <Col className="detalhes-do-booking-linha2">{c.booking.Pod}</Col>
                                <Col className="detalhes-do-booking-linha2">{c.booking.Destination}</Col>   
                                <Col className="detalhes-do-booking-linha2">{c.itens.map((v)=>
                                v.Iso
                                )}</Col>                             
                                <Col className="detalhes-do-booking-linha2">{c.booking.QtdAgendBkn}</Col>                                      
                                
                                </Row>                           
                                )
                            }
                            
                                                                  
                                            
                                                              
                                                
                    </div>
                    
                    <div className="detalhes">
                        {this.props.booking.dtRecebimento !== "" &&
                        <Col xs={12} md={6} lg={4} className="px-0 pb-4">
                            <h4 className="px-0">
                                Início recebimento: {this.props.booking.dtRecebimento ? moment(this.props.booking.dtRecebimento).format("DD/MM/YYYY HH:mm") : "---"}
                            </h4>
                        </Col>                                                
                        }
                        <Col>
                                {this.props.booking.dtRecebimento == "" && !this.props.booking.dtRecebimento && this.props.booking.dtRecebimento == null || lista && lista.length == 0 ?  "" : this.alertaSSA3()}
                                
                            </Col>
                        { this.state.refreshBooking   ? this.excluiDadosBooking()    : this.listaDadosBooking() }
                        { this.state.refreshContainer ? this.excluiDadosContainers() : this.parametrosStore.isAgendamentoVisible("ListaContainerContainer") && this.listaContainers() }                        
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/modules/agendamento/containers-cadastrar/entrada-containers/components/CardBooking.js